import { registerPlugin } from '@capacitor/core'
import type { TikTokSharePlugin } from './definitions'

const TikTokShare = registerPlugin<TikTokSharePlugin>('TikTokShare')

export * from './definitions'
export { TikTokShare }
